







































import { Event } from '@ssp/inscreva-sse-models';
import { Component, Prop, Vue } from 'vue-property-decorator';

import EventInfoCore from '@/components/EventInfoCore.vue';

import ImageSelect from './ImageSelect.vue';

@Component({
  components: {
    ImageSelect,
    EventInfoCore,
  },
})
export default class StepInfoComponent extends Vue {
  @Prop({ required: true })
  private event!: Event;

  get allowHeader() {
    return this.event.allowHeader;
  }

  get is_new_event(): boolean {
    return !this.event._id;
  }
}
